import { fetch_sadap } from "../../core/api"

export function getRoomByUUID() {
    const path = "chat/room/by-uuid"
    return fetch_sadap(path, "get", {}, false)
}

export function getRoomArchiveByUUID() {
    const path = "chat/room/archive"
    return fetch_sadap(path, "get", {}, false)
}

export function markAsRead(idRoom) {
    const path = "chat/room/read"
    return fetch_sadap(path, "post", {
        id: idRoom
    }, false)
}

export function markAsUnRead(idRoom) {
    const path = "chat/room/un-read"
    return fetch_sadap(path, "put", {
        id: idRoom
    }, false)
}

export function setAsAdmin(idAdmin, idRoom) {
    const path = "chat/room/admin"
    return fetch_sadap(path, "put", {
        admins_id: idAdmin,
        id: idRoom
    }, false)
}

export function removeAdmin(idAdmin, idRoom) {
    const path = "chat/room/admin?remove"
    return fetch_sadap(path, "put", {
        admins_id: idAdmin,
        id: idRoom
    }, false)
}

export function removeMember(idMember, idRoom) {
    const path = "chat/room/user"
    return fetch_sadap(path, "delete", {
        id: idRoom,
        member_id: idMember
    }, false)
}

export function addMemberToGroup(idMember, idRoom) {
    const path = "chat/room/user"
    return fetch_sadap(path, "post", {
        id: idRoom,
        member_id: idMember
    }, false)
}

